import { Inject, Injectable } from '@angular/core';
import {
    ENDPOINTS,
    OdataValueHelperInterface,
    ODataValueHelperModel,
    OnlineOnlyService,
    ValueHelperModel,
} from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class OdataValueHelperService implements OdataValueHelperInterface {
    public constructor(
        private readonly onlineOnlyService: OnlineOnlyService,
        @Inject(LogInstanceToken) private readonly log: LogInterface,
    ) {}

    public getValueHelpers(): Observable<ValueHelperModel[]> {
        return this.onlineOnlyService.get(ENDPOINTS.ValueHelpers).pipe(
            map((data: ODataValueHelperModel[]) => data.map((c) => ValueHelperModel.fromOData(c))),
            catchError((error) => {
                this.log.debug(
                    `OdataValueHelperService: getValueHelpers: Could not retrieve the ValueHelperSet with error '${JSON.stringify(
                        error,
                        Object.getOwnPropertyNames(error),
                    )}'`,
                );
                // TODO check if the return type is right
                return of([]);
            }),
        );
    }
}
